import { Breadcrumb, Col, Modal, Row, Spin, Tabs } from 'antd';
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Slider from 'react-slick';
import styled from 'styled-components';
import serviceAPI from '~/api/ServiceAPI';
import { IMAGES } from '~/assets/assetsPath';
import RequireLoginModal from '~/components/FormInputPhone';
import ItemService from '~/components/ItemService';
import { getNumberWithCommas } from '~/utils';
import styles from './SpaDetail.module.scss';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import { useSelector } from 'react-redux';

const cx = classNames.bind(styles);
const { TabPane } = Tabs;

const SlideImage = styled.div`
    .SpaDetail_content_service__GKDMf .SpaDetail_image-container__Mk12S {
        width: 100% !important;
        // width: 5000px;
    }
    ul {
        bottom: -110px;
        height: 100px;
        width: auto;
    }
    .slick-dots li {
        width: 15%;
        height: 100px;
    }
    img {
        vertical-align: top;
        width: 100%;
    }
`;

const TabsContainer = styled.div`
    .ant-tabs-tab {
        font-size: 20px;
        font-weight: 600;
        color: rgba(137, 137, 137, 1);
    }
    .ant-tabs-tab.ant-tabs-tab-active {
        border-bottom: 3px solid #311d4f !important;
        z-index: 2;
    }
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: #311d4f;
    }
    .ant-tabs-bottom > .ant-tabs-nav:before,
    .ant-tabs-bottom > div > .ant-tabs-nav:before,
    .ant-tabs-top > .ant-tabs-nav:before,
    .ant-tabs-top > div > .ant-tabs-nav:before {
        border-bottom: 3px solid #e2e2e2;
    }
`;

const SpaDetail = () => {
    const navigate = useNavigate();

    const userInfo = useSelector((state) => state.user.userInfo);
    const isLogin = userInfo?.id || '';
    // const isLogin = !!localStorage.getItem('token');
    const [isShowInputPhone, setIsShowInputPhone] = useState(false);

    const [isLoading, setIsLoading] = useState(false);

    const { service_id } = useParams();

    const [categoryId, setCategoryId] = useState();

    const [serviceInfo, setServiceInfo] = useState({});

    const [activeKey, setActiveKey] = useState('1');

    const [listService, setListService] = useState([]);

    const [pagination, setPagination] = useState({
        page: 1,
        limit: 6,
        total_item: 0,
        total_page: 0,
    });

    const onChangeTabs = (key) => {
        setActiveKey(key);
        console.log(key);
    };

    const settings = {
        customPaging: function (index) {
            return <img src={serviceInfo?.image_list[index]} alt="" />;
        },
        dots: true,
        dotsClass: 'slick-dots slick-thumb',
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };
    const handleGetOneService = async () => {
        setIsLoading(true);
        try {
            let service = {};
            const params = {
                fields: '["$all", {"unit": ["$all"]}]',
            };
            const res = await serviceAPI.getOneServiceAPI(service_id, params);

            if (res.code === 200) {
                service = { ...res.results.object };
                setCategoryId(res.results.object.category_service_id);
                handleGetFilterService(res.results.object.id, res.results.object.category_service_id, pagination.page);
            }

            setServiceInfo(service);
        } catch (err) {
            console.log(err);
        }
        setIsLoading(false);
    };
    const handleNavigateBookingService = () => {
        if (isLogin) {
            navigate(`/dat-lich/${service_id}`);
        } else {
            setIsShowInputPhone(true);
        }
    };

    const onRejectInputPhone = () => {
        setIsShowInputPhone(false);
    };
    const onAgreeInputPhone = () => {
        setIsShowInputPhone(false);
        navigate(`/dat-lich/${service_id}`);
    };

    const handleGetFilterService = async (serviceId, categoryId, page) => {
        try {
            let services = listService;
            let final = [];
            const params = {
                fields: '["$all", {"unit": ["$all"]}]',
                filter: service_id ? `{"category_service_id": "${categoryId}", "id": {"$ne": "${serviceId}"}}` : null,
                limit: pagination.limit,
                page: page,
            };
            const res = await serviceAPI.getListServiceAPI(params);

            if (res.code === 200) {
                services.push(...res.results.objects.rows);
                setPagination({
                    ...pagination,
                    page: page,
                    total_item: res.results.objects.count,
                    total_page: Math.ceil(res.results.objects.count / res.pagination.limit),
                });
            }
            if (services?.length) {
                final = [...new Map(services.map((item) => [item['id'], item])).values()];
            }

            setListService(final);
        } catch (err) {
            console.log(err);
        }
    };
    const handleSeeMore = () => {
        try {
            const nextPage = pagination.page + 1;
            handleGetFilterService(serviceInfo?.id, categoryId, nextPage);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        handleGetOneService();

        //eslint-disable-next-line
    }, [service_id]);

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangThongTinDichVu');
        // eslint-disable-next-line
    }, []);

    return (
        <div className={cx('wrapper')}>
            <div>
                <Breadcrumb className={cx('breadcrumb')}>
                    <Breadcrumb.Item>Service</Breadcrumb.Item>
                    <Breadcrumb.Item className={cx('breadcrumItemActive')}>Service Information</Breadcrumb.Item>
                </Breadcrumb>
            </div>
            {isLoading ? (
                <Row justify="center" align="middle" style={{ height: '500px' }}>
                    <Spin />
                </Row>
            ) : (
                <>
                    {serviceInfo?.id ? (
                        <>
                            <div className={cx('content_service')}>
                                <Row className={cx('content_service_row')}>
                                    <Col xs={24} sm={12} md={12} style={{ padding: '0px 7px' }}>
                                        {serviceInfo.image_list?.length ? (
                                            <SlideImage>
                                                <Slider {...settings}>
                                                    {serviceInfo.image_list?.map((item) => {
                                                        return (
                                                            <div className={cx('image-container')}>
                                                                <img src={item} alt="" />
                                                            </div>
                                                        );
                                                    })}
                                                </Slider>
                                            </SlideImage>
                                        ) : (
                                            <img
                                                className={cx('image_main')}
                                                src={serviceInfo.image || IMAGES.NewLogoCut}
                                                alt=""
                                            />
                                        )}
                                    </Col>
                                    <Col
                                        className={cx(
                                            serviceInfo?.image_list?.length
                                                ? 'service_detail'
                                                : 'service_detail_no_slide',
                                        )}
                                        xs={24}
                                        sm={12}
                                        md={12}
                                    >
                                        <Row className={cx('type')}>{serviceInfo?.category_name}</Row>
                                        <Row className={cx('name')}>{serviceInfo?.title}</Row>
                                        <Row className={cx('time')}>
                                            Time: <span>{serviceInfo?.execution_time} minutes</span>
                                        </Row>
                                        <Row align="middle" className={cx('price')}>
                                            <span className={cx('price_sale')}>
                                                {getNumberWithCommas(serviceInfo?.price - serviceInfo?.discount)}&nbsp;
                                                {serviceInfo?.unit_id ? `d/${serviceInfo?.unit?.value}` : 'd'}
                                            </span>
                                            {parseInt(serviceInfo?.discount) ? (
                                                <>
                                                    <span className={cx('price_origin')}>
                                                        {getNumberWithCommas(serviceInfo?.price)} &nbsp;
                                                        {serviceInfo?.unit_id ? `d/${serviceInfo?.unit?.value}` : 'd'}
                                                    </span>
                                                    <span className={cx('discount')}>
                                                        -
                                                        {Math.round((serviceInfo?.discount * 100) / serviceInfo?.price)}
                                                        %
                                                    </span>
                                                </>
                                            ) : null}
                                        </Row>
                                        <Row justify="center" className={cx('summary')}>
                                            {serviceInfo?.description}
                                        </Row>
                                        <Row justify="center">
                                            <div className={cx('button')} onClick={handleNavigateBookingService}>
                                                Schedule now
                                            </div>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                            <div
                                className={cx(
                                    serviceInfo.image_list?.length ? 'tabs_content' : 'tabs_content_no_slide',
                                )}
                            >
                                <TabsContainer>
                                    <Tabs defaultActiveKey={activeKey} onChange={onChangeTabs}>
                                        <TabPane tab="Process" key="1">
                                            {/* {data?.steps?.map((item, index) => {
                                return (
                                    <Row className={cx('item_step')} key={index}>
                                        <div>
                                            <img src={SVGS.IconStepService} alt="" />
                                            <span className={cx('text')}>{item}</span>
                                        </div>
                                    </Row>
                                );
                            })} */}
                                            {serviceInfo?.implementation_process ? (
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: serviceInfo?.implementation_process,
                                                    }}
                                                ></div>
                                            ) : (
                                                <span>No process yet!</span>
                                            )}
                                        </TabPane>
                                    </Tabs>
                                </TabsContainer>
                            </div>
                            {listService?.length ? (
                                <>
                                    <div className={cx('service_home_spa')}>
                                        <Row justify="center" className={cx('name_section')}>
                                            Related services
                                        </Row>
                                        <Row className={cx('container_service')}>
                                            {listService?.map((item, index) => {
                                                return (
                                                    <>
                                                        {item?.id !== serviceInfo?.id ? (
                                                            <Col xs={24} sm={12} lg={8} key={index}>
                                                                <Row>
                                                                    <ItemService data={item} />
                                                                </Row>
                                                            </Col>
                                                        ) : null}
                                                    </>
                                                );
                                            })}
                                        </Row>
                                    </div>
                                    {pagination?.page < pagination?.total_page && (
                                        <Row justify="center" style={{ marginTop: '30px' }}>
                                            <div className={cx('btn_see_more')} onClick={handleSeeMore}>
                                                see more
                                            </div>
                                        </Row>
                                    )}
                                </>
                            ) : (
                                <></>
                            )}
                        </>
                    ) : (
                        <Row justify="center" className={cx('service_no_exist')}>
                            Service does not exist
                        </Row>
                    )}
                </>
            )}

            {isShowInputPhone && (
                <Modal
                    centered
                    visible={isShowInputPhone}
                    onCancel={onRejectInputPhone}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={480}
                >
                    <div style={{ padding: '30px 10px 0px 10px' }}>
                        <RequireLoginModal onAgreeInputPhone={onAgreeInputPhone} />
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default SpaDetail;
